import React from 'react'
import {Row, Col, Input, DatePicker} from 'antd'

const Filter = ({filter, setFilter}) => {
  const onDatePickerOk = value => {
    setFilter({...filter, date: [value[0], value[1]]})
  }

  return (
    <div style={{padding: '.5em 0 2em'}}>
      <Row gutter={[20, 16]}>
        <Col md={24} lg={12} xl={8}>
          <Input.Search
            style={{width: '100%'}}
            onSearch={console.log}
            placeholder='Search in invoices (work in progress)'
          />
        </Col>
        <Col md={24} lg={12} xl={8}>
          <DatePicker.RangePicker
            style={{width: '100%'}}
            showTime={{format: 'HH:mm'}}
            format='YYYY-MM-DD HH:mm'
            placeholder={['Date from', 'To']}
            onOk={onDatePickerOk}
            allowClear={false}
          />
        </Col>
      </Row>
    </div>
  )
}

export default Filter
